import { h, Component } from 'preact';
import Store from 'store/store';
import { sortObjectByOrder, joinClasses } from 'utils/utils';
import s from 'components/bolt/footer/footer.sss';

export default class Footer extends Component {

	handleFooterClick(link) {
		const pageId = this.props.store?.activePage;
		if (link.id === 'privacy') {
			Store.emit('TRACK_PRIVACY_POLICY_CLICK', { id: pageId });
		}
		if (pageId.endsWith('AR')) {
			Store.emit('TRACK_AR_FOOTER_CLICK', { id: pageId, link });
		}
	}

	render(props) {
		const links = sortObjectByOrder(props?.data?.links);
		const arPageActive = props.store?.activePage && props.store.activePage.endsWith('AR');
		const shouldHideFooter = arPageActive && !props.isARFooter;

		return (
			<footer class={joinClasses(s.wrapper, shouldHideFooter && s.hide)}>
				{links.map(link => (
					<a href={link.url} target='_blank' class={s.link} ariaLabel={link.ariaLabel} onClick={() => this.handleFooterClick(link)}>
						{link.$copy}
					</a>
				))}
			</footer>
		);
	}
}
